import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import { AddLinkForm } from "../../components/AddLinkForm";
import Layout from "../../components/shared/Layout/Layout";

const AddFeaturePage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    if (edit && id && !grades) {
      getGradeList();
    }
  }, [id]);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Link`}>
        {edit && id && grades ? (
          <AddLinkForm
            edit={true}
            data={grades.filter((item) => item.id === parseInt(id))[0]}
          />
        ) : (
          <AddLinkForm />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.feature.feature,
});

export default connect(mapStateToProps, { getGradeList })(AddFeaturePage);
